import React from 'react';

import ssIMG from './img/ss_icon.svg';
import spIMG from './img/sp_icon.svg';
import shIMG from './img/sh_icon.svg';


import ssWPImg from '../../img/Hosting_Plans/wp_ss_icon.svg';
import spWPImg from '../../img/Hosting_Plans/wp_sp_icon.svg';
import shWPImg from '../../img/Hosting_Plans/wp_sh_icon.svg';

import ssDiscImg from './img/price-superstart.svg';
import spDiscImg from './img/price-superpro.svg';
import shDiscImg from './img/price-superhosting.svg';

import ssDiscImgEUR from './img/price-eur-superstart.svg';
import spDiscImgEUR from './img/price-eur-superpro.svg';
import shDiscImgEUR from './img/price-eur-superhosting.svg';

import wpai1Img from '../../img/Hosting_Plans/wpai-1.svg';
import wpai2Img from '../../img/Hosting_Plans/wpai-2.svg';
import wpai3Img from '../../img/Hosting_Plans/wpai-3.svg';

import {__t} from '../common/lang/text-resource';

const initialState = {
	data: {
		'plan_01': {
			icon: ssIMG,
			name: __t('СуперСтарт'),
			description: __t('Най-подходящ за личен блог или сайт'),
			mainFeatures: [
				__t('15 GB пространство'),
				__t('~ 12 000 посещения/мес.'),
				__t('Неограничен трафик'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 1'),
				__t('до 3 Backups + Professional Restore'),
				__t('Неограничен брой пощи'),
			],
			starsCount: 1,
			discountImage: ssDiscImg,
			discountImageEUR: ssDiscImgEUR,
		},
		'plan_02': {
			icon: spIMG,
			name: __t('СуперПро'),
			description: __t('Най-подходящ за фирмен сайт'),
			mainFeatures: [
				__t('50 GB пространство'),
				__t('~ 36 000 посещения/мес.'),
				__t('Неограничен трафик'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 3'),
				__t('до 5 Backups + Professional Restore'),
				__t('Неограничен брой пощи'),
			],
			starsCount: 3,
			discountImage: spDiscImg,
			discountImageEUR: spDiscImgEUR,
		},
		'plan_03': {
			icon: shIMG,
			name: __t('СуперХостинг'),
			description: __t('Най-подходящ за старт на онлайн магазин'),
			mainFeatures: [
				__t('150 GB пространство'),
				__t('~ 100 000 посещения/мес.'),
				__t('Неограничен трафик'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 6'),
				__t('до 7 Backups + Professional Restore'),
				__t('Неограничен брой пощи'),
				__t('Безплатен GogetSSL'),
				__t('SuperCache ускорител'),
			],
			starsCount: 6,
			discountImage: shDiscImg,
			discountImageEUR: shDiscImgEUR,
		},
		'plan_01_wp': {
			icon: ssWPImg,
			name: __t('СуперСтарт'),
			description: __t('Най-подходящ за личен WordPress блог'),
			mainFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('15 GB пространство'),
				__t('~ 12 000 посещения/мес.'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 1'),
				__t('до 3 Backups + Professional Restore'),
				__t('Неограничен трафик'),
			],
			starsCount: 1,
			discountImage: ssDiscImg,
			discountImageEUR: ssDiscImgEUR,
		},
		'plan_02_wp': {
			icon: spWPImg,
			name: __t('СуперПро'),
			description: __t('Най-подходящ за фирмен WordPress сайт'),
			mainFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('50 GB пространство'),
				__t('~ 36 000 посещения/мес.'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 3'),
				__t('до 5 Backups + Professional Restore'),
				__t('Неограничен трафик'),
				__t('Допълнително WordPress ускоряване'),
			],
			starsCount: 3,
			discountImage: spDiscImg,
			discountImageEUR: spDiscImgEUR,
		},
		'plan_03_wp': {
			icon: shWPImg,
			name: __t('СуперХостинг'),
			description: __t('Най-подходящ за WooCommerce магазин'),
			mainFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('150 GB пространство'),
				__t('~ 100 000 посещения/мес.'),
			],
			secondaryFeatures: [
				__t('Сървърна мощ x 6'),
				__t('до 7 Backups + Professional Restore'),
				__t('Неограничен трафик'),
				__t('Допълнително WordPress ускоряване'),
				__t('Безплатен GogetSSL'),
			],
			starsCount: 6,
			discountImage: shDiscImg,
			discountImageEUR: shDiscImgEUR,
		},
		'plan_wpai_01': {
			icon: wpai1Img,
			name: __t('Managed WP + AI Start'),
			description: __t('За лични блогове и малки проекти'),
			mainFeatures: [
				__t('15 GB пространство'),
				__t('3 бекъпа/седмица'),
				__t('Експертна WP поддръжка Mini'),
			],
			secondaryFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('Сайт асистент AI'),
				__t('Инсталиран плъгин за ускорение'),
				__t('WP Manager by SuperHosting.BG'),
			],
			starsCount: 1,
			discountImage: ssDiscImg,
			discountImageEUR: ssDiscImgEUR,
		},
		'plan_wpai_02': {
			icon: wpai2Img,
			name: __t('Managed WP + AI Advanced'),
			description: __t('За фирмени и презентационни сайтове'),
			mainFeatures: [
				__t('50 GB пространство'),
				__t('5 бекъпа/седмица'),
				__t('Експертна WP поддръжка Mini'),
			],
			secondaryFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('Сайт асистент AI'),
				__t('Инсталиран плъгин за ускорение'),
				__t('WP Manager by SuperHosting.BG'),
			],
			starsCount: 3,
			discountImage: spDiscImg,
			discountImageEUR: spDiscImgEUR,
		},
		'plan_wpai_03': {
			icon: wpai3Img,
			name: __t('Managed WP + AI Business'),
			description: __t('За сайтове с много данни и голям трафик'),
			mainFeatures: [
				__t('150 GB пространство'),
				__t('7 бекъпа/седмица'),
				__t('Експертна WP поддръжка Mini'),
			],
			secondaryFeatures: [
				__t('Готов инсталиран WordPress'),
				__t('Сайт асистент AI'),
				__t('Инсталиран плъгин за ускорение'),
				__t('WP Manager by SuperHosting.BG'),
			],
			starsCount: 6,
			discountImage: shDiscImg,
			discountImageEUR: shDiscImgEUR,
		}
	}
};

const ContextSharedHostingPlanData = React.createContext(initialState);

export default ContextSharedHostingPlanData;